<template>
  <!-- :unmount-on-close="true" -->
  <Modal
    :title="modalTitle"
    title-align="start"
    :align-center="false"
    :visible="visible"
    :closable="props.closable"
    :mask-closable="props.closable"
    :unmount-on-close="true"
    modal-class="training-program-editor training-modal"
    @update:visible="handleClose"
  >
    <Scrollbar>
      <div class="training-program-basis flex border-b border-dark-60 overflow-visible">
        <div class="w-[2.78rem] mr-105">
          <Form
            layout="vertical"
            :model="{}"
          >
            <FormItem :label="`${$t('R6001')} ${$t('R1013')}`">
              <Select
                ref="sport-type-select"
                :model-value="trainingProgram.sportType"
                class="basic-item sport-type-select relative !z-40"
                :disabled="readonly"
                :trigger-props="{ updateAtScroll: true }"
                @update:model-value="changeSportCategory"
              >
                <template #label="{ data: selectOptionData }">
                  <div class="flex flex-row justify-start items-center">
                    <span
                      class="program-edit-option-icon mr-8"
                      :class="[sportCategoryConfigMap[selectOptionData.value].icon]"
                      :style="{
                        color: sportCategoryConfigMap[selectOptionData.value].color,
                        'text-fill-color': sportCategoryConfigMap[selectOptionData.value].color
                      }"
                    ></span>
                    <span>{{ $t(sportCategoryConfigMap[selectOptionData.value].label) }}</span>
                  </div>
                </template>
                <Option
                  v-for="item in sportTypeOptions"
                  :key="item.icon"
                  :value="item.type"
                >
                  <div class="flex flex-row justify-start items-center">
                    <span
                      class="program-edit-option-icon mr-8"
                      :style="{ color: item.color }"
                      :class="item.icon"
                    ></span>
                    <span>{{ $t(item.label) }}</span>
                  </div>
                </Option>
              </Select>
            </FormItem>
            <FormItem :label="$t('R4027')">
              <Input
                :model-value="$t(trainingProgram.name)"
                @input="handleNameInputChange"
                :placeholder="$t('R1009')"
                :max-length="90"
                :disabled="readonly"
                :word-length="getStringByte"
                :word-slice="getStringByMaxBytes"
                class=""
              />
            </FormItem>

            <FormItem
              v-if="hasIntensityType"
              :label="$t('R6007')"
            >
              <Select
                v-model="trainingProgram.fastIntensityTypeName"
                class="basic-item fast-intensity-type border-dark-60 relative !z-30"
                :disabled="readonly"
                :trigger-props="{ updateAtScroll: true }"
                @change="handleChangeFastIntensityType"
              >
                <Option
                  v-for="item in fastIntensityTypeOptions"
                  :key="item.key"
                  :value="item.key"
                >
                  {{ item.nameText }}
                </Option>
                <Option value="custom">
                  {{ $t('T5064') }}
                </Option>
              </Select>
            </FormItem>

            <!-- 难度系统 -->
            <FormItem
              v-if="[6, 7].includes(trainingProgram.sportType)"
              :label="$t('S4658')"
            >
              <Select
                v-model="globalGradeSystem"
                class="basic-item fast-intensity-type border-dark-60 relative !z-30"
                :options="gradingSytemOptions"
                :disabled="readonly"
                :trigger-props="{ updateAtScroll: true }"
              >
              </Select>
            </FormItem>

            <SwimPoolLength
              :sport-type="trainingProgram.sportType"
              :readonly="readonly"
            />
          </Form>
        </div>
        <div class="flex-grow flex flex-col">
          <Form
            layout="vertical"
            :model="{}"
            class="flex flex-1 training-program-editor-form-right"
          >
            <FormItem :label="$t('R1011')">
              <Textarea
                :model-value="$t(trainingProgram.overview)"
                class="flex-1 h-full training-program-editor-textarea"
                show-word-limit
                :max-length="200"
                :disabled="readonly"
                @input="handleOverviewInputChange"
                :placeholder="$t('R1012')"
              />
            </FormItem>
          </Form>
        </div>
      </div>

      <div class="flex justify-between sticky top-0 sticky-bar h-60 bg-bg-3 items-center">
        <div class="flex flex-row justify-start items-center">
          <i class="iconfont iconicon_jichutubiao_shuoming1" />
          <span class="font-medium ml-8">{{ $t('R9011') }}</span>
        </div>
        <div v-if="!readonly">
          <Button
            type="outline"
            @click="addExercise"
          >
            <i class="iconfont iconicon_jichutubiao_tianjiakapian1 mr-8 inline-block" />{{ $t('R4010') }}
          </Button>
        </div>
      </div>
      <dl class="exercises-area">
        <dd
          ref="exercisesList"
          :class="['exercises-list', { 'no-event': readonly }]"
        >
          <template v-for="(exercise, index) in trainingProgram.exercises">
            <template v-if="exercise.exerciseList">
              <div
                :key="'exercise-' + index"
                class="py-16 border border-dark-60 mb-16 rounded erercise-sub-group"
                :data-group-id="exercise.groupId"
              >
                <div class="flex justify-between mb-12 items-center mx-16">
                  <div class="flex flex-row items-stretch group-info">
                    <div class="sets-name px-10 text-text-3 flex items-center">
                      {{ $t('R4014') }}
                    </div>
                    <InputNumber
                      v-model="exercise.sets"
                      class="sets-count"
                      :min="initStore.activityStrengthProfile.minSets"
                      :max="initStore.activityStrengthProfile.maxSets"
                      :controls="true"
                      mode="button"
                      :disabled="readonly"
                    />
                  </div>
                  <!--        操作按钮-->
                  <div
                    v-if="!readonly"
                    class="fixed-flex-item row-flex align-item-center exercise-operate"
                  >
                    <Tooltip
                      effect="dark"
                      :content="$t('R3008')"
                      placement="top"
                    >
                      <i
                        class="mr-40 cursor-pointer text-gray-palette-6 hover:text-white iconfont iconicon_jichutubiao_shanchu1 operate-icon"
                        @click="deleteExercise({ index })"
                      />
                    </Tooltip>
                    <Tooltip
                      effect="dark"
                      :content="$t('R3006')"
                      placement="top"
                    >
                      <i
                        class="mr-40 cursor-pointer text-gray-palette-6 hover:text-white iconfont iconicon_jichutubiao_fuzhi1 operate-icon"
                        @click="copyExercise({ index, exercise })"
                      />
                    </Tooltip>
                    <Tooltip
                      effect="dark"
                      :content="$t('R4010')"
                      placement="top"
                    >
                      <i
                        class="mr-16 cursor-pointer text-gray-palette-6 hover:text-white iconfont iconicon_jichutubiao_tianjiakapian1 operate-icon"
                        @click="addExercise({ index, exercise })"
                      />
                    </Tooltip>
                  </div>
                </div>
                <TrainingProgramSubItem
                  v-for="(groupExercise, groupExerciseIndex) in exercise.exerciseList"
                  :key="'group-exercise-' + groupExercise.exerciseUniqueId"
                  :data-exercise-id="groupExercise.exerciseUniqueId"
                  :data-group-id="exercise.groupId"
                  :is-strength="isStrength"
                  :container-id="exercise.groupId"
                  :sport-category-name="sportCategoryName"
                  :sport-type="trainingProgram.sportType"
                  :sport-config="sportConfig"
                  :class="['elastic-flex-item', 'mx-16', 'th-draggable text-white', { 'no-event': readonly }]"
                  :critical-power="currentCriticalPower"
                  :zone-data="currentZoneData"
                  :model-value="groupExercise"
                  :user="user"
                  :team-id="teamId"
                  :readonly="readonly"
                  :fast-intensity-type-name="trainingProgram.fastIntensityTypeName"
                  :global-grade-system="globalGradeSystem"
                  :group-index="index"
                  :index="groupExerciseIndex"
                  :exercise-type-options="exerciseTypeOptions"
                  :exercise-definition="trainingProgramStore.exercises"
                  :climbConfig="currentClimbConfig"
                  @update:model-value="(val) => (trainingProgram.exercises[index].exerciseList[groupExerciseIndex] = val)"
                  @change="changeExercise"
                  @delete="deleteExercise({ index: groupExerciseIndex, groupIndex: index })"
                  @add="addExercise({ index: groupExerciseIndex, groupIndex: index, exercise: groupExercise })"
                  @copy="copyExercise({ index: groupExerciseIndex, groupIndex: index, exercise: groupExercise })"
                  @changeGradeSystem="handleExerciseGradeSystemChange"
                />
              </div>
            </template>
            <template v-else>
              <TrainingProgramSubItem
                :key="'exercise-' + exercise.exerciseUniqueId"
                :data-exercise-id="exercise.exerciseUniqueId"
                :container-id="exercise.exerciseUniqueId"
                :is-strength="isStrength"
                :sport-type="trainingProgram.sportType"
                :sport-category-name="sportCategoryName"
                :sport-config="sportConfig"
                :class="['elastic-flex-item', 'th-draggable text-white', { 'no-event': readonly }]"
                :critical-power="currentCriticalPower"
                :zone-data="currentZoneData"
                :model-value="exercise"
                :user="user"
                :team-id="teamId"
                :readonly="readonly"
                :fast-intensity-type-name="trainingProgram.fastIntensityTypeName"
                :global-grade-system="globalGradeSystem"
                :index="index"
                :exercise-type-options="exerciseTypeOptions"
                :exercise-definition="trainingProgramStore.exercises"
                :climbConfig="currentClimbConfig"
                @update:model-value="(val) => (trainingProgram.exercises[index] = val)"
                @change="changeExercise"
                @delete="deleteExercise({ index })"
                @add="addExercise({ index, exercise })"
                @copy="copyExercise({ index, exercise })"
                @changeGradeSystem="handleExerciseGradeSystemChange"
              />
            </template>
          </template>
        </dd>
      </dl>
    </Scrollbar>
    <template #footer>
      <div class="flex items-center justify-between footer h-full">
        <div class="flex flex-row text-left text-white items-center font-medium">
          <template v-if="hasEstimateInfo">
            <div class="text-white">
              <span class="mx-5 text-text-3">{{ $t('R9012') }}</span>
              <template v-if="estimateInfo.pitch">
                <span class="font-bold">{{ estimateInfo.pitch }}</span>
                <span class="mx-5 text-text-3 text-12">{{ $t(programInfo.sportType === 7 ? 'H9095' : 'H9039') }}</span>
              </template>
              <template v-if="estimateInfo.sets">
                <span class="font-bold">{{ estimateInfo.sets }}</span>
                <span class="mx-5 text-text-3 text-12">{{ $t('H8004', { OvO: '' }) }}</span>
              </template>
              <template v-if="estimateInfo.duration">
                <span class="font-bold">{{ estimateInfo.duration }}</span>
                <span class="mx-5 text-text-3 text-12">min</span>
              </template>
              <template v-if="estimateInfo.distance">
                <span class="font-bold">{{ estimateInfo.distance }}</span>
                <span class="mx-5 text-text-3 text-12">{{ estimateInfo.distanceUnitName }}</span>
              </template>
              <template v-if="estimateInfo.trainingLoad">
                <span class="font-bold">{{ estimateInfo.trainingLoad }}</span>
                <span class="mx-5 text-text-3 text-12">TL</span>
              </template>
            </div>
            <div
              class="ml-10 text-14 font-medium"
              v-if="showCurrentDaySum"
            >
              <span class="estimate-item cti">{{ $t('SQ9005') }}</span>
              <span class="estimate-item cti mx-10">{{ estimateInfo.currentDaySum.planCti }}</span>
              <span class="estimate-item ati">{{ $t('SQ9006') }}</span>
              <span class="estimate-item ati mx-10">{{ estimateInfo.currentDaySum.planAti }}</span>
              <span class="estimate-item tired-rate">{{ $t('Y9081') }}</span>
              <span class="estimate-item tired-rate mx-10">
                {{ Math.round(estimateInfo.currentDaySum.planTrainingLoadRatio * 100) + '%' }}
              </span>
            </div>
          </template>
        </div>
        <template v-if="!footerBtnSlot">
          <div
            v-if="!readonly"
            class="flex-shrink-0"
          >
            <Button
              class="footer-btn cancel mr-16 min-w-90 font-medium"
              @click.stop="handleClose"
            >
              {{ $t('C1006') }}
            </Button>
            <Button
              type="primary"
              :class="['min-w-90', 'footer-btn', 'save', { active: isTrainingProgramValid }]"
              @click.stop="handleSave"
              :loading="saveLoading"
            >
              {{ $t('G1006') }}
            </Button>
          </div>
        </template>
        <slot
          name="footerBtn"
          :formData="{
            trainingProgram,
            currentZoneData,
            exercises: trainingProgramStore.exercises,
            sportConfig,
            currentUnit,
            currentCriticalPower
          }"
        ></slot>
      </div>
    </template>
  </Modal>
</template>
<script setup>
import { ref, computed, watch, getCurrentInstance, nextTick, onBeforeUpdate, onBeforeUnmount, useSlots, onMounted } from 'vue';
import {
  Message,
  Modal,
  Textarea,
  Form,
  FormItem,
  Input,
  InputNumber,
  Button,
  Select,
  Option,
  Tooltip,
  Scrollbar,
  InputGroup
} from '@arco-design/web-vue';
import { cloneDeep } from 'lodash';
import { instance as requestInstance } from '@client/helper/http';
import { training } from '@client/api';
import dayjs from 'dayjs';
import Definition from '@client/config/definition';
import { userStore as useUserStore } from '@client/store/userStore';
import { initStore as useAppStore } from '@client/store/initStore';
import { memberDataStore as memberDataStoreRef } from '@client/store/memberDataStore';
import { scheduleStore as useScheduleStore } from '@client/store/scheduleStore';
import { isNoValue } from '@client/helper/validate';
import { sportCategoryConfigMap } from '@client/config/sport';
import { getStringByMaxBytes, getStringByte } from '@client/helper/string';
import TrainingProgramSubItem from './TrainingProgramSubItem/index.vue';
import { parseSportConfig } from './TrainingProgramSubItem/utils';
import { trainingProgramDefaultData } from './constants';
import Sortable from './customSortable';
import Mirror from '@shopify/draggable/build/esnext/Draggable/Plugins/Mirror/Mirror.mjs';
import { useI18n } from 'vue-i18n';
import { trainingProgramStore as useTrainingProgramStore } from '@client/store/trainingProgramStore';
import * as corosSportConfig from '@coros/sport-config';
const { getGradingSytemOptions, isIndoorClimbOrBoulderingTrainingSportType } = corosSportConfig.sport.climb;
import SwimPoolLength from '../programEdit/components/SwimPoolLength/index.vue';
import {
  changeIntensity,
  getExerciseNum,
  toGroupTypeExercises,
  toComponentExercises,
  getGlobalIntensityTypeName,
  getNewInfoAfterChangeFastIntensityType,
  generateExerciseUniqueId,
  dealSavingData
} from './utils';
import { getCalculateInfo } from '../trainingEdit/utils';
import { useSwimPoolLength, getSavePoolLength } from './hooks/useSwimPoolLength';
import { checkFirstExerciseTargetUnitIsYardOrMile } from './utils/swim';

const MAX_EXERCISE_COUNT = 40;

const vm = getCurrentInstance();
const { t } = useI18n();
Message._context = vm.appContext;
Modal._context = vm.appContext;
const footerBtnSlot = !!useSlots().footerBtn;
const userStore = useUserStore();
const initStore = useAppStore();
const scheduleStore = useScheduleStore();
const memberDataStore = memberDataStoreRef();

const props = defineProps({
  readonly: {
    type: Boolean,
    default: false
  },
  visible: {
    type: Boolean,
    default: false
  },
  user: {
    type: Object,
    default: () => ({})
  },
  teamId: {
    type: String,
    default: ''
  },
  programInfo: {
    type: Object,
    default: () => ({ sportType: 1, name: '', overview: '', fastIntensityTypeName: 'custom', exercises: [] })
  },
  from: {
    type: String,
    default: 'template'
  },
  operateType: {
    type: String,
    default: 'add'
  },
  // 训练课程分享页, 不允许关闭
  closable: {
    type: Boolean,
    default: true
  },
  // 是否一致使用当前用户的难度系统
  useCurrentUserClimbConfig: {
    type: Boolean,
    default: null
  }
});

const emits = defineEmits(['update:visible', 'success', 'onSave', 'onCancel']);

const exercisesList = ref(null);
const saveLoading = ref(false);
const trainingProgram = ref({ sportType: 1, name: '', overview: '', fastIntensityTypeName: 'custom', exercises: [] });
const trainingProgramStore = useTrainingProgramStore();

const {
  poolLengthType,
  customPoolLength,
  distanceOptions,
  poolLengthUnit,
  init: initSwimPoolLength,
  clear: clearSwimPool,
  checkAndAlertPoolLengthChange,
  alertSetDefaultPoolLength
} = useSwimPoolLength();

onMounted(() => {
  // 泳池长度变更提示
  watch(poolLengthType, (newVal, oldVal) => {
    if (!props.visible) {
      return;
    }
    checkAndAlertPoolLengthChange(oldVal, newVal);
  });
});

const isTrainingProgramValid = computed(() => {
  if (trainingProgram.value.sportType && trainingProgram.value.exercises && trainingProgram.value.exercises.length > 0) {
    return true;
  }

  return false;
});

const modalTitle = computed(() => {
  let result = 'R4001';
  if (props.operateType === 'add') {
    result = 'R4003';
  }
  return t(result);
});
const sportCategoryName = computed(() => {
  return Definition.sportCategoryName[trainingProgram.value.sportType];
});

const isStrength = computed(() => {
  return ['strength'].includes(sportCategoryName.value);
});

const currentCriticalPower = computed(() => {
  const { teamViewMode, userData } = memberDataStore;
  if (teamViewMode && userData.criticalPower) {
    return userData.criticalPower;
  }

  return userStore.criticalPower;
});

const currentZoneData = computed(() => {
  const { teamViewMode, userData } = memberDataStore;
  if (teamViewMode && userData.zoneData) {
    // 团队模式
    return userData.zoneData;
  }
  return userStore.zoneData;
});
const currentModelValidState = computed(() => {
  if (props.user.hasOwnProperty('modelValidState')) {
    return !!props.user.modelValidState;
  }

  return userStore.sportDataSummary.modelValidState;
});

const sportConfig = computed(() => {
  let unit = currentUnit.value;
  return parseSportConfig(trainingProgram.value.sportType, currentZoneData.value, t, unit, currentCriticalPower.value);
});

const currentUnit = computed(() => {
  const defaultUnit = userStore.unit;
  if (props.user.unit !== undefined) {
    return props.user.unit;
  }
  // 原来还有个计划单位
  if (props.programInfo && props.programInfo.unit !== undefined) {
    return props.programInfo.unit;
  }

  return defaultUnit;
});
// ['run', 'trailRun', 'bike', 'swim', 'strength']
const sportTypeOptions = [1, 5, 2, 3, 4, 6, 7].map((type) => {
  return sportCategoryConfigMap[type];
});

const fastIntensityTypeOptions = computed(() => {
  if (!sportCategoryName.value) {
    return [];
  }

  // TODO: 确认cloneDeep 是否有必要
  const intensity = cloneDeep(sportConfig.value.train.intensity);

  const optionsFilter = (options) => {
    let arr = [];
    options.forEach((item) => {
      if (item.key === 'notSet') return;

      if (Array.isArray(item.children)) {
        arr = arr.concat(optionsFilter(item.children));
        return item.children.length > 0;
      }

      arr.push(item);
    });

    return arr;
  };

  const result = optionsFilter(intensity.options);
  return result;
});

const hasIntensityType = computed(() => {
  return ['run', 'trailRun', 'bike'].includes(sportCategoryName.value);
});

const changeExercise = (data) => {
  // const { groupIndex, index, exercise } = data;
  // const exercises = cloneDeep(trainingProgram.value.exercises);
  // console.log(999, exercises, groupIndex);
  // if (isNoValue(groupIndex)) {
  //   console.log(222, data);
  //   // 没有分组id
  //   const addingIndex = isNoValue(index) ? exercises.length : index;
  //   exercises.splice(addingIndex, 1, exercise);
  // } else {
  //   // 有分组index
  //   exercises[groupIndex].exerciseList.splice(index, 1, exercise);
  // }
  // trainingProgram.value.exercises = exercises;
};
const handleNameInputChange = (val) => {
  trainingProgram.value.name = val;
};
const handleOverviewInputChange = (val) => {
  trainingProgram.value.overview = val;
};
const changeSportCategory = (val) => {
  const operateProgram = props.programInfo || {};

  function setDefaultExercises() {
    trainingProgram.value.exercises = [];
    trainingProgram.value.sportType = val;
    trainingProgram.value.name = '';
    trainingProgram.value.overview = '';
    const { teamId = '', userId: teamUserId } = getUserParams();
    const userId = teamUserId || userStore.userId;
    trainingProgramStore.getExercises(teamId, userId, val).then(() => {
      const newInfo = cloneDeep(trainingProgramDefaultData[Definition.sportCategoryName[val]]);
      let exercises = [];

      // 健身类型，不使用模板中的默认动作，使用动作库中训练动作
      if (isStrength.value) {
        for (let n = 0, length = trainingProgramStore.exercises.length; n < length; n++) {
          const item = trainingProgramStore.exercises[n];
          if ([2, '2'].includes(item.defaultOrder)) {
            exercises = toGroupTypeExercises(
              [item],
              trainingProgramStore.exercises,
              sportConfig.value,
              currentCriticalPower.value,
              currentZoneData.value
            );
          }
        }
      } else {
        exercises = toGroupTypeExercises(
          newInfo.exercises,
          trainingProgramStore.exercises,
          sportConfig.value,
          currentCriticalPower.value,
          currentZoneData.value,
          false,
          {
            climbConfig: currentClimbConfig.value,
            globalGradeSystemVal: globalGradeSystem.value,
            poolLengthUnit: poolLengthUnit.value,
            poolLengthId: 1
          }
        );
      }

      // 检查是否分组内仅有一个动作
      exercises = exercises.map((item) => {
        if (!item.groupId) {
          return item;
        }
        if (item.exerciseList.length > 1) {
          return item;
        }

        const newItem = item.exerciseList[0];
        if (['time', 'distance'].includes(newItem.targetTypeName)) {
          newItem.targetCount[newItem.targetTypeName].value = newItem.targetCount[newItem.targetTypeName].value * item.sets;
        }
        return newItem;
      });

      newInfo.exercises = exercises;

      // 设置全局强度
      newInfo.fastIntensityTypeName = getGlobalIntensityTypeName(newInfo, sportConfig.value);

      if (isStrength.value) {
        newInfo.fastIntensityTypeName = 'weight';
      }

      // 如果是编辑的，需要使用原来的id
      if (props.operateType === 'edit') {
        newInfo.id = operateProgram.id;
        newInfo.idInPlan = operateProgram.idInPlan;
        newInfo.version = operateProgram.version;
        newInfo.unit = operateProgram.unit;
      }

      trainingProgram.value = getNewInfoAfterChangeFastIntensityType(newInfo, newInfo.fastIntensityTypeName, sportConfig.value, true);
    });
  }

  if (trainingProgram.value.sportType === '') {
    if (props.operateType === 'add') {
      setDefaultExercises();
      return;
    } else {
      return;
    }
  }

  if (trainingProgram.value.name === '' && trainingProgram.value.overview === '' && trainingProgram.value.exercises.length === 0) {
    setDefaultExercises();
    return;
  }

  if (trainingProgram.value.sportType === val) {
    return;
  }

  Modal.warning({
    title: t('C1001'),
    content: t('R4029'),
    okText: t('C1005'),
    cancelText: t('C1006'),
    titleAlign: 'start',
    hideCancel: false,
    modalClass: 'coros-modal-footer-right',
    onOk: () => {
      nextTick(setDefaultExercises);
    }
  });
  // .catch(() => {
  //   // that.$refs['sport-type-select'].setActiveValue(that.info.sportType);
  // });
};

const addExercise = (data) => {
  const globalFastIntensityTypeName = trainingProgram.value.fastIntensityTypeName;

  const exercises = cloneDeep(trainingProgram.value.exercises);
  const { groupIndex, index, exercise } = data;
  if (exercise && exercise.groupId) {
    // 是添加分组的事件
    const exerciseList = trainingProgramStore.exercises
      .filter((item) => {
        const exerciseTypeName = Definition.exerciseTypeName[item.exerciseType];
        if (isStrength.value) {
          return (['train'].includes(exerciseTypeName) && item.defaultOrder !== 0) || ['rest'].includes(exerciseTypeName);
        }
        return (['train'].includes(exerciseTypeName) && [1, '1'].includes(item.isDefaultAdd)) || ['rest'].includes(exerciseTypeName);
      })
      .map((item) => {
        const newItem = toComponentExercises(
          item,
          trainingProgramStore.exercises,
          sportConfig.value,
          currentCriticalPower.value,
          currentZoneData.value,
          // convert 是否公英制转换
          false,
          {
            climbConfig: currentClimbConfig.value,
            globalGradeSystemVal: globalGradeSystem.value,
            poolLengthUnit: poolLengthUnit.value,
            poolLengthId: 1
          }
        );
        if (globalFastIntensityTypeName === 'custom') {
          return newItem;
        }

        newItem.intensityTypeName = globalFastIntensityTypeName;

        return newItem;
      });
    // 生成新的分组
    const group = {
      groupId: new Date().getTime(),
      sets: 2,
      exerciseList
    };
    exercises.splice(index + 1, 0, group);
  } else {
    const exerciseList = trainingProgramStore.exercises
      .filter((item) => {
        const exerciseTypeName = Definition.exerciseTypeName[item.exerciseType];
        if (isStrength.value) {
          return ['train'].includes(exerciseTypeName) && item.defaultOrder !== 0;
        }
        return [1, '1'].includes(item.isDefaultAdd);
      })
      .map((item) => {
        let newItem = toComponentExercises(
          item,
          trainingProgramStore.exercises,
          sportConfig.value,
          currentCriticalPower.value,
          currentZoneData.value,
          // convert 是否公英制转换
          false,
          {
            isAddingNew: true,
            climbConfig: currentClimbConfig.value,
            globalGradeSystemVal: globalGradeSystem.value,
            poolLengthUnit: poolLengthUnit.value,
            customPoolLength: customPoolLength.value,
            distanceOptions: distanceOptions.value,
            poolLengthId: 1
          }
        );
        if (globalFastIntensityTypeName !== 'custom') {
          newItem = changeIntensity(newItem, globalFastIntensityTypeName, sportConfig.value);
        }

        return newItem;
      });
    const result = exerciseList[0];

    if (!result) {
      return;
    }

    if (isNoValue(groupIndex)) {
      // 没有分组id
      const addingIndex = isNaN(index + 1) ? exercises.length : index + 1;
      exercises.splice(addingIndex, 0, result);
    } else {
      // 有分组index
      exercises[groupIndex].exerciseList.splice(index + 1, 0, result);
    }
  }

  // 判断是否超过数量
  if (getExerciseNum(exercises) >= MAX_EXERCISE_COUNT) {
    Message.error(t('R4031'));
    return;
  }

  trainingProgram.value.exercises = exercises;
};

// 复制动作
const copyExercise = (data) => {
  if (trainingProgram.value.exercises.length >= MAX_EXERCISE_COUNT) {
    Message.error(t('R4031'));
    return;
  }

  const { groupIndex, index, exercise } = data;
  const exercises = cloneDeep(trainingProgram.value.exercises);

  if (exercise.exerciseList) {
    exercise.groupId = generateExerciseUniqueId();
    exercise.exerciseList.forEach((item) => {
      item.exerciseUniqueId = generateExerciseUniqueId();
    });
  } else {
    exercise.exerciseUniqueId = generateExerciseUniqueId();
  }

  if (isNoValue(groupIndex)) {
    // 没有分组id
    exercises.splice(index, 0, exercise);
  } else {
    // 有分组index
    exercises[groupIndex].exerciseList.splice(index, 0, exercise);
  }

  // 判断是否超过数量
  if (getExerciseNum(exercises) >= MAX_EXERCISE_COUNT) {
    Message.error(t('R4031'));
    return;
  }

  trainingProgram.value.exercises = exercises;
};
// 删除动作
const deleteExercise = (data) => {
  const { groupIndex, index } = data;
  let exercises = cloneDeep(trainingProgram.value.exercises);

  if (isNoValue(groupIndex)) {
    // 没有分组id
    exercises.splice(index, 1);
  } else {
    // 有分组index
    exercises[groupIndex].exerciseList.splice(index, 1);
    if (exercises[groupIndex].exerciseList.length === 0) {
      exercises.splice(groupIndex, 1);
    }
  }

  // 检查是否分组内仅有一个动作
  exercises = exercises.map((item) => {
    if (!item.groupId) {
      return item;
    }
    if (item.exerciseList.length > 1) {
      return item;
    }

    const newItem = item.exerciseList[0];
    if (['time', 'distance'].includes(newItem.targetTypeName) && !isNoValue(newItem.targetCount[newItem.targetTypeName])) {
      newItem.targetCount[newItem.targetTypeName].value = newItem.targetCount[newItem.targetTypeName].value * item.sets;
    }
    return newItem;
  });

  trainingProgram.value.exercises = exercises;
};

const makeDefaultInfo = async (from, type, sportType = trainingProgram.value.sportType) => {
  let newInfo = {};
  const { teamId = '', userId: teamUserId } = getUserParams();
  const userId = teamUserId || userStore.userId;
  const climbConfig = currentClimbConfig.value;
  // 是否第一个动作是英制单位
  let swimPoolIsYard = false;
  switch (type) {
    case 'add':
      if (sportType) {
        await trainingProgramStore.getExercises(teamId, userId, sportType);
      }

      newInfo = cloneDeep(trainingProgramDefaultData[Definition.sportCategoryName[sportType]]);

      newInfo.exercises = toGroupTypeExercises(
        newInfo.exercises,
        trainingProgramStore.exercises,
        sportConfig.value,
        currentCriticalPower.value,
        currentZoneData.value,
        false,
        {
          climbConfig,
          globalGradeSystemVal: globalGradeSystem.value,
          poolLengthUnit: poolLengthUnit.value,
          // 泳池长度应该默认是25M，也就是默认是id 1
          poolLengthId: 1
        }
      );
      break;
    case 'edit':
      if (props.programInfo.sportType === 3) {
        // 旧数据才检查
        if (typeof props.programInfo.poolLengthId === 'undefined') {
          swimPoolIsYard = checkFirstExerciseTargetUnitIsYardOrMile(props.programInfo.exercises);
          alertSetDefaultPoolLength(swimPoolIsYard);
        }
      }
      newInfo = cloneDeep(props.programInfo);
      trainingProgram.value.sportType = newInfo.sportType;
      await trainingProgramStore.getExercises(teamId, userId, newInfo.sportType);

      newInfo.exercises = toGroupTypeExercises(
        newInfo.exercises,
        trainingProgramStore.exercises,
        sportConfig.value,
        currentCriticalPower.value,
        currentZoneData.value,
        true,
        {
          climbConfig,
          globalGradeSystemVal: globalGradeSystem.value,
          poolLengthUnit: poolLengthUnit.value,
          poolLengthId: props.programInfo.poolLengthId,
          swimPoolIsYard
        }
      );
      break;
    default:
      if (props.programInfo.sportType === 3) {
        // 旧数据才检查
        if (typeof props.programInfo.poolLengthId === 'undefined') {
          swimPoolIsYard = checkFirstExerciseTargetUnitIsYardOrMile(props.programInfo.exercises);
          if (type !== 'share') {
            alertSetDefaultPoolLength(swimPoolIsYard);
          }
        }
      }
      newInfo = cloneDeep(props.programInfo);
      trainingProgram.value.sportType = newInfo.sportType || 1;
      if (type === 'share') {
        await trainingProgramStore.getExercises(teamId, userId, newInfo.sportType);
      }
      newInfo.exercises = toGroupTypeExercises(
        newInfo.exercises,
        trainingProgramStore.exercises,
        sportConfig.value,
        currentCriticalPower.value,
        currentZoneData.value,
        true,
        {
          climbConfig,
          globalGradeSystemVal: globalGradeSystem.value,
          poolLengthUnit: poolLengthUnit.value,
          poolLengthId: props.programInfo.poolLengthId,
          swimPoolIsYard
        }
      );
      break;
  }

  // 初始化泳池长度等

  if (type === 'detail') {
    const { poolLengthId, poolLength, poolLengthUnit } = props.programInfo.programs[0];
    initSwimPoolLength(poolLengthId, poolLength, poolLengthUnit, true, swimPoolIsYard);
  } else {
    initSwimPoolLength(newInfo.poolLengthId, newInfo.poolLength, newInfo.poolLengthUnit, props.readonly, swimPoolIsYard);
  }

  // newInfo.pbVersion = 2;

  /* 遍历所有动作，决定全局强度类型 begin */
  newInfo.fastIntensityTypeName = getGlobalIntensityTypeName(newInfo, sportConfig.value);
  // 室内攀岩、抱石有全局难度系统设置
  if (isIndoorClimbOrBoulderingTrainingSportType(newInfo.sportType)) {
    if (newInfo.referExercise) {
      console.log(`初始化 globalGradeSystem.value`, newInfo.referExercise.gradeSystem);
      globalGradeSystem.value = newInfo.referExercise.gradeSystem || 'custom';
    }
  }
  /* 遍历所有动作，决定全局强度类型 end */

  if (isStrength.value) {
    newInfo.fastIntensityTypeName = 'weight';
  }

  // if (that.isThirdPartyPlan) {
  //   if (!newInfo.name) {
  //     newInfo.name = t(Definition.getSportCategoryByValue(newInfo.sportType).i18n);
  //   }
  //   newInfo.exercises.forEach((item) => {
  //     if (!item.name) {
  //       item.name = t(Definition.getExerciseTypeInfoByName(item.exerciseType).i18n);
  //     }
  //   });
  // }
  const data = getNewInfoAfterChangeFastIntensityType(newInfo, newInfo.fastIntensityTypeName, sportConfig.value, type === 'add');
  trainingProgram.value = data;
};

const handleOpen = async () => {
  trainingProgramStore.clearExercises();
  makeDefaultInfo(props.from, props.operateType);
};

const handleClose = () => {
  clearSwimPool();
  trainingProgramStore.clearExercises();
  trainingProgram.value = {
    sportType: 1,
    name: '',
    overview: '',
    exercises: []
  };

  if (['copy'].includes(props.from)) {
    // this.$bus.$emit(`copy-save-success`, {});
  }
  emits('update:visible', false);

  emits('onCancel');
};

const handleSortAfterDrop = (e) => {
  const getGroupArr = (root, str) => {
    if (str) {
      return root.find((item) => item.groupId === str)?.exerciseList;
    }

    return root;
  };

  if (e.position) {
    const newExercises = cloneDeep(trainingProgram.value.exercises);
    const overIsGroup = e.overGroupId && !e.over;
    const targetArr = getGroupArr(newExercises, overIsGroup ? '' : e.overGroupId);
    const fromArr = getGroupArr(newExercises, e.sourceGroupId);
    const fromIndex = fromArr.findIndex((item) => item.exerciseUniqueId === e.source);

    const fromItem = fromArr[fromIndex];

    if (e.position === 'center') {
      const overIndex = targetArr.findIndex((item) => (overIsGroup ? item.groupId === e.overGroupId : item.exerciseUniqueId === e.over));
      targetArr[overIndex] = {
        groupId: `${Date.now()}`,
        exerciseList: [targetArr[overIndex], fromItem],
        sets: 2
      };
      // 编组依赖顺序，在编组前删除源动作会导致编组数据有问题。
      fromArr.splice(fromIndex, 1);
    } else {
      fromArr.splice(fromIndex, 1);
      const overIndex = targetArr.findIndex((item) => (overIsGroup ? item.groupId === e.overGroupId : item.exerciseUniqueId === e.over));
      const moveIndex = e.position === 'top' ? overIndex : overIndex + 1;
      if (fromIndex === moveIndex && targetArr === fromArr) {
        console.log('Nothing changed!');
        return;
      }
      targetArr.splice(moveIndex, 0, fromItem);
    }

    newExercises.forEach((item, index) => {
      if (item.exerciseList && item.exerciseList.length <= 1) {
        newExercises[index] = item.exerciseList[0];
      }
    });

    trainingProgram.value.exercises = newExercises;
  }
};

let sortableInstance = null;
watch(
  () => props.visible,
  (val) => {
    if (val) {
      handleOpen();
      nextTick(() => {
        sortableInstance = new Sortable(exercisesList.value, {
          draggable: '.th-draggable',
          handle: '.iconicon_jichutubiao_yidong',
          mirror: {
            appendTo: 'body',
            constrainDimensions: true
          },
          exclude: {
            plugins: [Mirror]
          }
        });
        sortableInstance.on('sortable:stop', handleSortAfterDrop);
      });
    } else {
      handleClose();
      sortableInstance.off('sortable:stop', handleSortAfterDrop);
      sortableInstance.destroy();
      sortableInstance = null;
    }
  }
);

// 组合出接口需要的数据格式
const makeAddingData = (program) => {
  let { PB_VERSION: pbVersion } = initStore;
  const { happenDay, dayNo, sortNoInPlan, sortNoInSchedule } = scheduleStore.activeScheduleData;
  let idInPlan = scheduleStore.maxIdInPlan + 1;
  pbVersion = program.pbVersion || pbVersion;
  const result = {
    entities: [
      {
        // 发生的日期
        happenDay,
        // 与训练方案相关联的id
        idInPlan,
        // 每一天中训练的排序
        sortNo: 0,
        dayNo: dayNo || 0,
        sortNoInPlan: sortNoInPlan || 0,
        sortNoInSchedule: sortNoInSchedule || 0
      }
    ],
    programs: [
      {
        ...program,
        idInPlan
      }
    ],
    versionObjects: [
      {
        id: idInPlan,
        status: 1
      }
    ],
    pbVersion
  };

  return result;
};

const getUserParams = () => {
  const { teamViewMode, userData } = memberDataStore;
  if (['template'].includes(props.from)) {
    return {};
  }
  if (teamViewMode && userData) {
    const { userId, teamId } = userData;
    return {
      userId,
      teamId
    };
  } else {
    return {};
  }
};

// 调用接口计算program的数值
const calculateProgram = (program) => {
  // 泳池长度
  program.poolLengthId = poolLengthType.value;
  program.poolLength = getSavePoolLength();
  program.poolLengthUnit = poolLengthUnit.value;

  const info = trainingProgram.value;
  // 处理未登录情况下workout 的计算
  if (!userStore.accessToken) {
    return new Promise((resolve, reject) => {
      const { distance, duration, totalSets, pitch, trainingLoad, distanceDisplayUnit } = info;
      resolve({
        planDistance: distance,
        planDuration: duration,
        planSets: totalSets,
        // TODO: todo_climb 这里是否是 pitch?
        planPitch: pitch,
        planTrainingLoad: trainingLoad,
        distanceDisplayUnit
      });
    });
  }
  return new Promise((resolve, reject) => {
    training
      .api4CalculateTrainingProgram({
        params: getUserParams(),
        data: program
      })
      .then(({ data }) => {
        resolve(data.value);
      });
  });
};

// 将模板信息存储到服务器
const saveTemplateToServer = async (e, callback) => {
  callback = callback || function () {};

  const url =
    {
      add: training.addProgram,
      edit: training.updateProgram
    }[props.operateType] || '';

  const options = {
    url,
    method: 'post',
    params: getUserParams(),
    data: dealSavingData(
      trainingProgram.value,
      currentZoneData.value,
      trainingProgramStore.exercises,
      sportConfig.value,
      currentUnit.value,
      currentCriticalPower.value,
      { globalGradeSystemVal: globalGradeSystem.value }
    )
  };

  try {
    const mathInfo = await calculateProgram(options.data);
    options.data.distance = mathInfo.planDistance;
    options.data.duration = mathInfo.planDuration;
    options.data.trainingLoad = mathInfo.planTrainingLoad;
    options.data.sets = mathInfo.planSets;
    options.data.pitch = mathInfo.planPitch;
    options.data.totalSets = mathInfo.planSets;
    if (mathInfo.exerciseBarChart) options.data.exerciseBarChart = mathInfo.exerciseBarChart;
  } catch (err) {
    Message.error('error');
  }

  return requestInstance(options)
    .then((data) => {
      Message.success(t('R4030'));
      return Promise.resolve(data);
    })
    .catch((err) => {
      console.error(err);
      return Promise.reject(err);
    });
};

// 保存模板的新增或修改数据
const templateSaving = (e) => {
  saveLoading.value = true;
  saveTemplateToServer(e)
    .then((data) => {
      if (props.from === 'template' && props.operateType === 'add') {
        // that.$store.dispatch('traceTimeEnd', {
        //   eventName: 'CreateTrainingProgram',
        //   eventTitle: '',
        //   params: {
        //     account_type: that.$store.state?.userData?.role,
        //     program_id: data
        //   }
        // });
      }
      // that.$bus.$emit(`${that.site}-right-bar-workout-programs-refresh`, {});
      handleClose();
      emits('success', data);
    })
    .finally(() => {
      saveLoading.value = false;
    });
};
// 导入页中保存编辑之后的模板
const copySaving = (e) => {
  saveTemplateToServer(e).then(() => {
    // that.$bus.$emit(`copy-save-success`, {});
  });
};
// 保存日程修改数据
const scheduleEditSaving = async (e) => {
  const { happenDay } = scheduleStore.activeScheduleData;
  const entitie = cloneDeep(scheduleStore.activeCalendCardSportData);
  const { planProgramId, idInPlan, planId } = entitie;
  const program = dealSavingData(
    trainingProgram.value,
    currentZoneData.value,
    trainingProgramStore.exercises,
    sportConfig.value,
    currentUnit.value,
    currentCriticalPower.value,
    { globalGradeSystemVal: globalGradeSystem.value }
  );
  saveLoading.value = true;
  try {
    const { planDistance, planDuration, planTrainingLoad, planSets, planPitch, exerciseBarChart } = await calculateProgram(program);
    program.distance = planDistance;
    program.duration = planDuration;
    program.trainingLoad = planTrainingLoad;
    program.sets = planSets;
    program.pitch = planPitch;
    program.totalSets = planSets;
    if (exerciseBarChart) program.exerciseBarChart = exerciseBarChart;
  } catch (err) {
    Message.error('error');
  }
  const data = {
    entities: [entitie],
    programs: [program],
    versionObjects: [
      {
        id: idInPlan,
        // 1：新增、2：修改、3：删除
        status: 2,
        planProgramId,
        planId
      }
    ],
    pbVersion: program.pbVersion || initStore.PB_VERSION
  };
  const params = getUserParams();
  training
    .api4UpdateSchedule({ data, params })
    .then(({ response }) => {
      const result = response.value.result;
      if (result !== '0000') {
        if (result === '40001') Message.error(t(`E${result}`));
      } else {
        Message.success(t('R4030'));
      }
      saveLoading.value = false;
      emits('onSave', happenDay);
    })
    .catch((err) => {
      console.error(err);
      saveLoading.value = false;
    });
};
// 保存组合修改数据
const planEditSaving = async (e) => {
  const entitie = cloneDeep(scheduleStore.activeCalendCardSportData);
  const { planProgramId, idInPlan, planId } = entitie;

  const program = dealSavingData(
    trainingProgram.value,
    currentZoneData.value,
    trainingProgramStore.exercises,
    sportConfig.value,
    currentUnit.value,
    currentCriticalPower.value,
    { globalGradeSystemVal: globalGradeSystem.value }
  );
  // saveLoading.value = true;
  const { name, overview } = trainingProgram.value;
  entitie.name = name;
  entitie.overview = overview;
  program.planId = planId;
  try {
    const { planDistance, planDuration, planTrainingLoad, planSets, planPitch, exerciseBarChart, distanceDisplayUnit } =
      await calculateProgram(program);
    program.distance = planDistance;
    program.duration = planDuration;
    program.trainingLoad = planTrainingLoad;
    program.sets = planSets;
    program.pitch = planPitch;
    program.totalSets = planSets;
    if (exerciseBarChart) program.exerciseBarChart = exerciseBarChart;
    program.distanceDisplayUnit = distanceDisplayUnit;
  } catch (err) {
    Message.error('error');
  }
  const data = {
    entities: [entitie],
    programs: [program],
    versionObjects: [
      {
        // program中的idInPlan
        id: idInPlan,
        // id: idInPlan,
        // 1：新增、2：修改、3：删除
        status: 2,
        planProgramId: planProgramId
      }
    ]
  };
  const { operateType } = props;
  emits('onSave', { data, operateType });
};
// 直接保存到日历上
const planAddSaving = async (e) => {
  if (saveLoading.value) return;
  saveLoading.value = true;
  const programData = dealSavingData(
    trainingProgram.value,
    currentZoneData.value,
    trainingProgramStore.exercises,
    sportConfig.value,
    currentUnit.value,
    currentCriticalPower.value,
    { globalGradeSystemVal: globalGradeSystem.value }
  );
  let mathInfo;
  try {
    mathInfo = await calculateProgram(programData);
    programData.distance = mathInfo.planDistance;
    programData.duration = mathInfo.planDuration;
    programData.trainingLoad = mathInfo.planTrainingLoad;
    programData.sets = mathInfo.planSets;
    programData.totalSets = mathInfo.planSets;
    programData.pitch = mathInfo.planPitch;
    if (mathInfo.exerciseBarChart) {
      programData.exerciseBarChart = mathInfo.exerciseBarChart || [];
    }
    programData.distanceDisplayUnit = mathInfo.distanceDisplayUnit;
  } catch (err) {
    Message.error('error');
  }

  const data = makeAddingData(programData);
  if (mathInfo.exerciseBarChart) {
    data.entities[0].exerciseBarChart = mathInfo.exerciseBarChart || [];
  }
  const { operateType } = props;
  if (props.from === 'plan') {
    // 回传数据
    saveLoading.value = false;
    emits('onSave', { data, operateType });
    // that.updateMaxIdInPlan();

    return;
  }
  const { happenDay } = scheduleStore.activeScheduleData;
  const { maxIdInPlan } = scheduleStore;
  const params = getUserParams();
  training
    .api4UpdateSchedule({
      data,
      params
    })
    .then((res) => {
      scheduleStore.updateMaxIdInPlan(maxIdInPlan + 1);
      Message.success(t('R1101'));
      saveLoading.value = false;
      emits('onSave', happenDay);
    })
    .catch((err) => {
      saveLoading.value = false;
      console.error(err);
    });
};

const handleSave = () => {
  if (!trainingProgram.value.name.trim()) {
    Message.error(t('R4032'));
    return;
  }
  if (!trainingProgram.value.exercises || trainingProgram.value.exercises.length === 0) {
    Message.error(t('R4033'));
    return;
  }

  // 保存泳池长度
  trainingProgram.value.poolLengthId = poolLengthType.value;
  trainingProgram.value.poolLength = getSavePoolLength();
  // console.log(`trainingProgram.value.poolLength`, trainingProgram.value.poolLength);
  trainingProgram.value.poolLengthUnit = poolLengthUnit.value;

  if (['template'].includes(props.from)) {
    templateSaving();
    return;
  }

  if (['copy'].includes(props.from)) {
    copySaving();
    return;
  }

  if (['plan'].includes(props.from)) {
    if (['add'].includes(props.operateType)) {
      planAddSaving();
    }
    if (['edit'].includes(props.operateType)) {
      planEditSaving();
    }
    return;
  }

  if (['schedule'].includes(props.from)) {
    if (['add'].includes(props.operateType)) {
      planAddSaving();
    }
    if (['edit'].includes(props.operateType)) {
      scheduleEditSaving();
    }
  }
};

const exerciseTypeOptions = computed(() => {
  if (!trainingProgramStore.exercises) {
    return [];
  }
  const result = trainingProgramStore.exercises.map((item) => {
    const exerciseTypeName = Definition.exerciseTypeName[item.exerciseType];
    return {
      ...item,
      key: exerciseTypeName,
      nameText: t(item.name)
    };
  });
  return result;
});

let estimateTimeout;
const estimateInfo = ref({});
const showCurrentDaySum = computed(() => {
  return (
    currentModelValidState.value && estimateInfo.value.currentDaySum
    // this.happenDay >= today
  );
});
const hasEstimateInfo = computed(() => {
  if (
    !estimateInfo.value.pitch &&
    !estimateInfo.value.duration &&
    !estimateInfo.value.distance &&
    !estimateInfo.value.trainingLoad &&
    !showCurrentDaySum.value
  ) {
    return false;
  }
  return true;
});
// 调用接口计算增加该训练组合后当天的统计数据
const getEstimate = () => {
  let { happenDay } = scheduleStore.activeScheduleData;
  const today = Number(dayjs().format('YYYYMMDD'));
  clearTimeout(estimateTimeout);
  estimateTimeout = setTimeout(async () => {
    if (!isTrainingProgramValid.value) {
      estimateInfo.value = {};
      return;
    }

    const data = makeAddingData(
      dealSavingData(
        trainingProgram.value,
        currentZoneData.value,
        trainingProgramStore.exercises,
        sportConfig.value,
        currentUnit.value,
        currentCriticalPower.value,
        { globalGradeSystemVal: globalGradeSystem.value }
      )
    );
    const { operateInfo } = props;
    const entity = data.entities[0];
    const program = data.programs[0];
    if (props.readonly) {
      happenDay = '';
    }

    // 泳池长度
    program.poolLengthId = poolLengthType.value;
    program.poolLength = getSavePoolLength();
    program.poolLengthUnit = poolLengthUnit.value;

    if (['template', 'plan'].includes(props.from) || happenDay < today) {
      const mathInfo = await calculateProgram(
        dealSavingData(
          trainingProgram.value,
          currentZoneData.value,
          trainingProgramStore.exercises,
          sportConfig.value,
          currentUnit.value,
          currentCriticalPower.value,
          { globalGradeSystemVal: globalGradeSystem.value }
        )
      );
      const {
        planDistance: distance,
        distanceDisplayUnit,
        planDuration: duration,
        planPitch: pitch,
        planSets: sets,
        planTrainingLoad: trainingLoad
      } = mathInfo;
      estimateInfo.value = getCalculateInfo({
        distance,
        distanceDisplayUnit,
        duration,
        pitch,
        sets,
        trainingLoad,
        currentUnit: currentUnit.value,
        program
      });
      return;
    }

    entity.planProgramId = operateInfo && operateInfo.entities && operateInfo.entities.planProgramId;
    entity.planId = data.programs && program && program.planId;

    training
      .api4ProgramEstimate({
        params: getUserParams(),
        data: {
          entity,
          program
        }
      })
      .then(({ data }) => {
        const { currentDaySum, distance, distanceDisplayUnit, duration, pitch, sets, trainingLoad } = data.value;
        estimateInfo.value = getCalculateInfo({
          currentDaySum,
          distance,
          distanceDisplayUnit,
          duration,
          pitch,
          sets,
          trainingLoad,
          currentUnit: currentUnit.value,
          program
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }, 500);
};

watch(() => trainingProgram.value.exercises, getEstimate, {
  deep: true
});

const handleChangeFastIntensityType = (val) => {
  trainingProgram.value = getNewInfoAfterChangeFastIntensityType(trainingProgram.value, val, sportConfig.value, true);
};
onBeforeUpdate(() => {
  saveLoading.value = false;
});
onBeforeUnmount(() => {
  if (sortableInstance) {
    sortableInstance.destroy();
    sortableInstance = null;
  }
});

// 全局难度系统
const globalGradeSystem = ref('custom');
const gradingSytemOptions = ref([]);
// 攀岩不是初始 sportType
watch(
  () => trainingProgram.value.sportType,
  (val) => {
    if (val) {
      gradingSytemOptions.value = getGradingSytemOptions(val, {
        addCustomOption: true,
        addNotSetOption: false
      });
      globalGradeSystem.value = 'custom';
    }
  }
);

// 子项的难度系统改了，这里要变成自定义
function handleExerciseGradeSystemChange(subGradeSystem) {
  // 已经是自定义就忽略
  if (subGradeSystem === 0 && globalGradeSystem.value !== 'custom') {
    globalGradeSystem.value = 'custom';
  }
  if (subGradeSystem !== 0) {
    console.error('不应该出现非0的其他难度系统', subGradeSystem);
  }
}

const currentClimbConfig = computed(() => {
  if (props.useCurrentUserClimbConfig) {
    console.log(`useCurrentUserClimbConfig  `, props.useCurrentUserClimbConfig);
    return userStore.climbConfig;
  }
  const { teamViewMode, userData } = memberDataStore;
  const climbConfig = teamViewMode ? userData.climbConfig : userStore.climbConfig;
  return climbConfig;
});
</script>

<style lang="scss">
@import '@client/styles/_mixins.scss';
@import '../trainingEdit/reset.scss';

.program-edit-option-icon {
  width: px2rem144(16);
}

.exercise-operate {
  display: none;
}

.erercise-sub-group:hover {
  .exercise-operate {
    display: block;
  }
}

.training-program-editor {
  width: px2rem144(1392);
  height: calc(100% - px2rem144(64));
  margin-top: px2rem144(32);
  display: flex;
  flex-direction: column;
  top: 0;

  .training-program-editor-form-right {
    .arco-form-item-layout-vertical {
      @apply flex;
      @apply flex-col;
      @apply justify-start;
      @apply flex-1;

      .arco-form-item-content-wrapper {
        @apply flex-1;
        @apply items-stretch;
      }

      .arco-form-item-wrapper-col {
        @apply flex-1;
      }

      .arco-form-item-content {
        @apply flex-1;
      }
    }
  }

  .estimate-item {
    &.ati {
      color: var(--ati-color);
    }

    &.cti {
      color: var(--cti-color);
    }

    &.tired-rate {
      color: var(--tired-rate-color);
    }
  }

  .arco-modal-header {
    height: px2rem144(73);

    .arco-icon-close {
      font-size: px2rem144(24);
    }
  }

  .arco-modal-body {
    padding-top: 0;
    padding-inline: px2rem144(32);
    // 输入类背景色
    // height: 100%;
    flex-grow: 1;
  }

  .training-program-basis {
    padding-top: px2rem144(16);
    padding-bottom: px2rem144(37);
  }

  .training-program-basis__item-label {
    color: #aaa;
  }

  .sticky-bar {
    // background: #181e30;
    z-index: 10;

    .arco-btn {
      min-width: px2rem144(110);
    }
  }

  .arco-input-number-mode-button {
    width: px2rem144(122);

    .arco-input {
      text-align: center;
    }
  }

  .arco-modal-footer {
    background: #323d5a;
    border-radius: 0 0 10px 10px;
    border-top: 0;
    height: px2rem144(64);
    font-size: 14px;

    .arco-btn-outline.cancel {
      color: hsla(0, 0%, 100%, 0.6);
      border-color: hsla(0, 0%, 100%, 0.2);
    }
  }

  .arco-textarea {
    resize: none;
  }
}

.draggable-mirror {
  z-index: 9999;
}
</style>
